export const companyData = [
  {
    id: "r0023",
    company_logo: "/assets/images/pi/logo.jpg",
    company_name: "Redwood Research",
    company_dirs: [
      "Mr. Srikanth Meenakshi, Co-founder",
      "Ms. Vidya Bala, Co-founder",
      "Ms.Bhavana Acharya, Co-founder",
    ],
    size: "8",
    ceo: "Mr. Srikanth Meenakshi",
    website: "https://primeinvestor.in",
    email: "srikanth@primeinvestor.in",
    category: "Financial Research",
    type: "StartUp",
    company_det:
      "Provides unbiased, independent research and recommendations across personal finance products such as stocks, mutual funds, ETFs, deposits, term insurance and more.",
  },
  {
    id: "r7845",
    company_logo: "/assets/images/lamp/logo.jpg",
    company_name: "Lamp Finmart Pvt Ltd",
    company_dirs: [
      "Mr.Narasimhan Venkataraman, Director",
      "Mr.Sekar Sundaram Prasanth, Director",
    ],
    category: "asset management",
    type: "StartUp",
    size: "9",
    ceo: "Mr. N.Venkataraman",
    website: "www.lampfinmart.com",
    email: "lightalamp2019@gmail.com",
    company_det:
      "Lein Asset Management, Non performing assets Sale data through interactive portal with a yearly subscription.",
  },
  {
    id: "l1034",
    company_logo: "/assets/images/tn/logo.png",
    company_name: "Transact Nexus Technology Pvt Ltd",
    company_dirs: ["Mr Sathish Kumar, CEO"],
    category: "Fintech",
    type: "StartUp",
    size: "9",
    ceo: "Mr. Sathish Kumar M",
    website: "https://transactnow.co.in/",
    email: "sathish.kumar@transactnow.co.in",
    company_det:
      "Transact Nexus Tech Pvt Ltd is a new age Fintech organization to cater to unbanked, underserved, migrant and rural population in India. It operates under the brand name of Transactnow.   We believe access to financial services is not a luxury, It's a necessity and we empower the last mile customer with the financial digital services powered by cash. In a simple statement we can say that we are creating a next-door banking solution through nearby retail stores through B2B2C model through our widespread network of distributors and retailers across India. We offer products like Aadhaar Enabled payment services, Domestic Money remittance, Recharges, Utility Bill Payments, Bus/Train/Flight/Hotel bookings, Cash In & Cash Out Services, Micro ATM's, Assisted E-commerce, Farmer Loan Eco System, GST Ready CRM Based Super POS and finally aiming to become a reputed brand in Neo Banking. Transactnow has now been selected to be part of the Govt of India's first Fin Tech Incubation Initiative – Fin Blue.",
  },
];
